/**
 * A saída de uma tela de painel.
 *
 * O painel não tem navegação de propósito: numa tela pendurada, todo
 * controle é um jeito de alguém deixar o quadro num estado do qual ninguém
 * vai tirar. Mas "sem navegação" virou "sem saída" — quem abre o painel no
 * próprio computador fica preso e só escapa pelo botão do navegador.
 *
 * São coisas diferentes: NAVEGAR dentro do painel é o que não pode; SAIR
 * dele é o mínimo. A diferença aparece no peso visual — este botão é
 * discreto de propósito, some no canto e não convida ao clique ocioso, mas
 * está sempre visível porque numa tela de toque não existe `hover` pra
 * revelar nada.
 *
 * Em aba nova o histórico está vazio e "voltar" não leva a lugar nenhum, por
 * isso o destino é explícito e não `navigate(-1)`.
 */

import { Link } from "react-router-dom";
import { X } from "lucide-react";

export function SairDoPainel({ para }: { para: string }) {
  return (
    <Link
      to={para}
      className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-slate-400 transition-colors hover:bg-surface-100 hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 dark:text-slate-600 dark:hover:bg-slate-800 dark:hover:text-slate-300"
    >
      <X className="h-3.5 w-3.5" aria-hidden />
      Sair do painel
    </Link>
  );
}
